import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class MyAccountService {
  option: any;
  encryptedData: any;
  userInfo: any = {};
  language: any;
  isActive = false;
  constructor(private http: HttpClient) {
    this.updateLocal();
  }
  updateLocal() {
    this.language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );

    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      const user = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      this.userInfo = user;
    }
    const headers = new HttpHeaders()
      .set("language", this.language)
      .set("Authorization", "Bearer " + this.userInfo.token)
      .set("Content-Type", "application/x-www-form-urlencoded");
    this.option = { headers };
  }
  changePassword(data): Observable<any> {
    this.updateLocal();
    const body = new HttpParams()
      .set("oldPassword", data.old_password)
      .set("newPassword", data.new_password);
    return this.http
      .put(environment.apiBaseUrl + "changePassword", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  subscription(): Observable<any> {
    this.updateLocal();
    return this.http.get(
      environment.planApiUrl + "retrieve-subscription",
      this.option
    );
  }

  cancelPlane(gatway): Observable<any> {
    this.updateLocal();
    if (gatway == "google") {
      return this.http.delete(
        environment.apiUrl + "android/subscription/cancel",
        this.option
      );
    } else {
      return this.http.delete(
        environment.planApiUrl + "delete-subscription",
        this.option
      );
    }
  }

  getProfile(): Observable<any> {
    this.updateLocal();
    return this.http
      .get(environment.apiUrl + "/get_profile", this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  subscriptionHistory(): Observable<any> {
    this.updateLocal();
    return this.http
      .get(environment.planApiUrl + "subscriptions/history", this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  purchaseHistory(): Observable<any> {
    this.updateLocal();
    return this.http
      .get(environment.planApiUrl + "purchase/history", this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  contactUs(data): Observable<any> {
    this.updateLocal();
    const body = new HttpParams()
      .set("subject", data.subject)
      .set("query", data.message)
      .set("email", this.userInfo.email)
      .set("name", this.userInfo.name)
      .set("rtoken", data.rtoken);
    return this.http
      .post(environment.apiUrl + "contactUs", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
}
